import React, { useState, useRef, Fragment, useEffect ,useCallback} from 'react';
import Logo from "../../images/logo-black.png";
import { toast } from 'react-toastify';
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { clearErrors, resendEmailAction, verifyEmailAction, verifyEmailTimeAction } from "../../../redux/actions/userActions";
import Loader from '../../loader/loader';
import { RESEND_EMAIL_RESET } from '../../../redux/constants/userConstant';

const VerifyEmail = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const { loading, expiryTime } = useSelector((state) => state.verifyTime);
    const {
        loading: resendEmailLoading,
        message,
        expireTime: resendEmailTime,
        error: resendEmailError
    } = useSelector((state) => state.resendEmail);
    const { isAuthenticated, error, loading: verifyEmailLoading, user } = useSelector((state) => state.verifyEmailStore);

    // 6-digit code
    const [codes, setCodes] = useState(['', '', '', '', '', '']);
    // useRef to hold an array of input DOM nodes (do NOT call useRef in a callback)
    const inputRefs = useRef([]);

    const [time, setTime] = useState(120); // 2 minutes default
    const [ActuallTime, setActuallTime] = useState("02:00");
    const [email, setEmail] = useState("");

    // Timer tick
    useEffect(() => {
        if (time > 0) {
            const timer = setTimeout(() => {
                setTime(prevTime => prevTime - 1);
            }, 1000);
            return () => clearTimeout(timer);
        }
    }, [time]);

    // Format time display
    useEffect(() => {
        const minutes = Math.floor(time / 60);
        const seconds = time % 60;
        const formattedTime = `${minutes < 10 ? '0' : ''}${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;
        setActuallTime(formattedTime);
    }, [time]);

    // Handle typing and focus movement
    const handleChange = (index, e) => {
        const value = e.target.value.replace(/[^0-9]/g, ''); // Ensure only numbers
        const val = value.slice(-1); // Keep last char
        const newCodes = [...codes];
        newCodes[index] = val;
        setCodes(newCodes);

        // Move to next input
        if (val && index < codes.length - 1) {
            const next = inputRefs.current[index + 1];
            if (next) {
                setTimeout(() => next.focus(), 10);
            }
        }
    };

    // Handle backspace properly
    const handleKeyDown = (index, e) => {
        if (e.key === "Backspace") {
            if (!codes[index] && index > 0) {
                const prev = inputRefs.current[index - 1];
                if (prev) {
                    const newCodes = [...codes];
                    newCodes[index - 1] = '';
                    setCodes(newCodes);
                    prev.focus();
                }
            }
        }
    };

    // Handle paste (allow pasting full 6-digit code)
    const handlePaste = (e) => {
        e.preventDefault();
        const pasteData = e.clipboardData.getData('text/plain').trim();
        const pastedChars = pasteData.split('').slice(0, codes.length);
        if (pastedChars.length === 0) return;

        const newCodes = [...codes];
        pastedChars.forEach((ch, idx) => {
            newCodes[idx] = ch;
        });
        setCodes(newCodes);

        // Focus the last filled input (or last input)
        const lastIndex = Math.min(pastedChars.length - 1, codes.length - 1);
        const el = inputRefs.current[lastIndex];
        if (el) el.focus();
    };

     const handleSubmit = useCallback(() => {
         const tokenStr = codes.join('');
 
         if (tokenStr.length === 6 && tokenStr.trim().length === 6) {
 
             const user = {
                 email,
                 token: tokenStr,
             };
 
             dispatch(verifyEmailAction(user));
 
         } else {
             toast.error("Please enter full 6-digit code.");
         }
 
     }, [codes, email, dispatch]);

    // Automatically submit when all 6 digits are filled
    useEffect(() => {
        const fullCode = codes.join('');
        if (fullCode.length === 6 && fullCode.trim().length === 6) {
            handleSubmit();
        }
    }, [codes, handleSubmit]);

    const resend = () => {
        if (!email) {
            toast.error("Credentials lost. Please Login again");
            return;
        }
        dispatch(resendEmailAction({ email }));
    };

    useEffect(() => {
        setEmail(localStorage.getItem("email"));
    }, []);

    useEffect(() => {

        if (error && error !== "Please login to access this resource") {
            toast.error(error);
            dispatch(clearErrors());
        }

        if (isAuthenticated && user) {


            if (user?.phone_number) {
                navigate("/");
            } else {
                navigate("/add-user-details");
            }
        }

        document.title = `VERIFY YOUR EMAIL`;


    }, [error, dispatch, isAuthenticated, navigate, user]);

    useEffect(() => {
        if (email) {
            dispatch(verifyEmailTimeAction({ email }));
        }
        let timer;
        if (!email) {
            timer = setTimeout(() => {
                navigate("/login");
            }, 500);
        }
        return () => clearTimeout(timer);
    }, [email, dispatch, navigate]);

    useEffect(() => {
        if (message) {
            toast.info(message);
            dispatch({ type: RESEND_EMAIL_RESET })
        }
        if (message && resendEmailTime) {
            settingTimefunction(resendEmailTime);
        }
    }, [message, resendEmailTime, dispatch]);

    useEffect(() => {
        if (expiryTime) {
            settingTimefunction(expiryTime);
        }
    }, [expiryTime]);


    useEffect(() => {
        if (resendEmailError) {
            toast.error(resendEmailError);
            dispatch(clearErrors());
        }
    }, [resendEmailError, dispatch]);


    const settingTimefunction = (expiryTimeParaMeter) => {
        if (!expiryTimeParaMeter) {
            console.error("No expiryTime received");
            return;
        }
        const expiryDate = new Date(expiryTimeParaMeter).getTime();
        const now = Date.now();
        if (isNaN(expiryDate)) {
            console.error("Invalid expiry date:", expiryTimeParaMeter);
            return;
        }
        let remainingSeconds = Math.floor((expiryDate - now) / 1000);
        if (remainingSeconds < 0) remainingSeconds = 0;
        setTime(remainingSeconds);
    };




    useEffect(() => {

        document.title = 'VERIFY EMAIL'

    }, [])


    return (
        <Fragment>
            {loading || resendEmailLoading || verifyEmailLoading ? (
                <Loader />
            ) : (
                <section className="relative min-h-[100vh] w-full flex bg-white font-jakarta overflow-x-hidden">

                    {/* Left Side: Dark & Corporate (Hidden on mobile) */}
                    <div className="hidden lg:flex lg:w-[45%] bg-zinc-900 p-[5vmax] flex-col justify-between relative">
                        <div className="absolute inset-0 bg-[linear-gradient(to_bottom_right,rgba(255,255,255,0.05),transparent)] pointer-events-none"></div>

                        <div className="relative z-10">
                            <img src={Logo} alt="Zonify Pro" className="w-[35%] invert" />
                        </div>

                        <div className="relative z-10">
                            <span className="text-indigo-400 font-semibold uppercase text-sm tracking-widest mb-3 block">Security Check</span>
                            <h2 className="text-[3.5vmax] font-bold text-white leading-none mb-[1.5vmax]">Protecting your account.</h2>
                            <p className="text-[1.1vmax] text-zinc-400 font-light max-w-[85%] leading-relaxed">
                                We take security seriously. Please verify your email address to ensure your account is protected.
                            </p>
                        </div>

                        <div className="relative z-10 text-zinc-500 text-[0.85vmax] flex items-center gap-4">
                            <span>© 2026 Zonify Pro</span>
                            <span className="w-1 h-1 bg-zinc-700 rounded-full"></span>
                            <span>Privacy Policy</span>
                            <span className="w-1 h-1 bg-zinc-700 rounded-full"></span>
                            <span>Terms of Service</span>
                        </div>
                    </div>

                    {/* Right Side: Verification Form */}
                    <div className="flex-1 min-w-0 w-full flex items-center justify-center p-6 lg:p-12 bg-white relative">

                        <div className="w-[calc(100vw_-_3rem)] max-w-md sm:w-full" data-aos="fade-up" data-aos-duration="1000">

                            {/* Logo for mobile only */}
                            <div className="flex justify-center mb-8 lg:hidden">
                                <img src={Logo} alt="Zonify Pro" className="w-32" />
                            </div>

                            <div className="mb-8 text-center lg:text-left">
                                <h4 className="text-2xl lg:text-3xl font-bold text-zinc-900 mb-2">Verify your email</h4>
                                <p className="text-sm lg:text-base text-zinc-500">
                                    We've sent a 6-digit verification code to
                                    <br />
                                    <span className="inline-block mt-2 px-3 py-1 bg-zinc-100 text-zinc-900 rounded-md font-semibold border border-zinc-200">{email}</span>
                                </p>
                            </div>

                            <div className="flex flex-col w-full">
                                {/* 6 Digit Code Inputs */}
                                <div className="flex justify-between gap-2 mb-6">
                                    {codes.map((code, index) => (
                                        <input
                                            key={index}
                                            ref={(el) => (inputRefs.current[index] = el)}
                                            type="text"
                                            inputMode="numeric"
                                            autoComplete="one-time-code"
                                            maxLength={1}
                                            value={code}
                                            onChange={(e) => handleChange(index, e)}
                                            onKeyDown={(e) => handleKeyDown(index, e)}
                                            onPaste={handlePaste}
                                            className="w-12 h-14 text-center border border-zinc-200 rounded-lg focus:border-zinc-900 focus:ring-1 focus:ring-zinc-900 bg-white transition-all text-xl font-bold text-zinc-900 outline-none shadow-sm"
                                        />
                                    ))}
                                </div>

                                <div className="text-sm text-zinc-500 text-center lg:text-left mb-6">
                                    Didn't get the code?{" "}
                                    <button className="text-zinc-900 font-semibold hover:underline transition-colors" onClick={resend}>
                                        Click to Resend
                                    </button>
                                </div>

                                <div className="flex justify-center lg:justify-start items-center gap-2 text-sm font-medium text-zinc-600 bg-zinc-50 px-4 py-2 rounded-lg mb-6 max-w-max">
                                    <i className="fa-regular fa-clock text-zinc-500"></i>
                                    <span>Time remaining:</span>
                                    <span className="font-bold text-zinc-900">{ActuallTime}</span>
                                </div>

                                <button
                                    className={`w-full py-3 rounded-lg font-medium text-sm lg:text-base transition-all
                                    ${ActuallTime === "00:00" ?
                                            "bg-zinc-100 text-zinc-400 cursor-not-allowed" :
                                            "bg-zinc-900 text-white hover:bg-zinc-800 shadow-sm hover:shadow-md"}`}
                                    onClick={handleSubmit}
                                    disabled={ActuallTime === "00:00"}
                                >
                                    Verify My Account
                                </button>
                            </div>
                        </div>
                    </div>
                </section>
            )}
        </Fragment>
    );
};

export default VerifyEmail;
